<template>
  <div class="child-page-div">
    <div class="page-content-div">
      <table-box ref="tableBox" :tableTitle="'视频管理'" :tableFieldNum="tableFieldNum" :action="action" :params="queryParams" :reloadData.sync="reloadData">
        <template #title-right>
          <div class="search-div">
            <label>
              <select v-model="queryParams.sort">
                <option value="">全部视频</option>
                <option value="1">基础视频</option>
                <option value="2">专题培训</option>
                <option value="3">属具安装</option>
                <option value="4">视频案例</option>
              </select>
            </label>
            <label>
              <select v-model="searchType">
                <option value="1">名称</option>
              </select>
            </label>
            <label>
              <input class="search-input" type="text" maxlength="20" v-model="searchMsg" placeholder="搜索相关数据..." />
            </label>
            <input class="search-btn" type="button" value="搜索" @click="onSearch" />
          </div>
        </template>
        <template #table-head>
          <th v-for="(item, index) in tableField" v-show="item.state" :key="index">{{ item.alias }}</th>
          <th v-if="isOperation" class="operation-th">操作</th>
        </template>
        <template v-if="$validateAuthority(2500000,2502000,2502001)" #tableSubHead>
          <th class="table-sub-head-th" :colspan="tableFieldNum">
            <div class="div-btn cursor-el append-btn" @click="onShowAdd">
              <img src="../../assets/add-data.png" height="14" width="14" alt="" />
              <label class="cursor-el">上传视频</label>
            </div>
          </th>
        </template>
        <template #table-body="props">
          <tr>
            <template v-for="(item, index) in tableField">
              <td v-if="item.isHtml" :key="index" v-show="item.state" v-html="item.value(props.item, item.name)" />
              <td v-else :key="index" v-show="item.state">{{ item.value(props.item, item.name) }}</td>
            </template>
            <td v-if="isOperation">
              <div class="operation-btn-div">
                <span class="cursor-el" @click.stop="onToCommentsPage(props.item)">查看评论</span>
                <span class="cursor-el" @click.stop="onToQuestionPage(props.item)">查看提问</span>
                <template v-if="$validateAuthority(2500000,2502000,2502002)">
                  <span v-if="props.item.state === 1" class="cursor-el" @click.stop="onChangeState(props.item, false)">禁用</span>
                  <span v-else class="cursor-el" @click.stop="onChangeState(props.item, true)">启用</span>
                </template>
                <span v-if="$validateAuthority(2500000,2502000,2502008)" class="cursor-el" @click.stop="onShowEdit(props.item.id)">编辑</span>
                <span v-if="$validateAuthority(2500000,2502000,2502003)" class="cursor-el" @click.stop="onDel(props.item)">删除</span>
              </div>
            </td>
          </tr>
        </template>
      </table-box>
    </div>
  </div>
</template>

<script>
import TableBox from "../../components/TableBox";
import VideoAddLayer from "../layer/VideoAddLayer";
import VideoEditLayer from "../layer/VideoEditLayer";
import { getLecturerVideoItems, postLecturerVideoState, postLecturerVideoDel } from "@/common/api";

export default {
  name: "Videos",
  components: { TableBox },
  data() {
    return {
      action: getLecturerVideoItems,
      reloadData: false,
      searchType: "1",
      searchMsg: "",
      queryParams: {
        type: 0,
        msg: "",
        pageSize: 20,
        sort: ""
      },
      tableField: [
        { state: true, alias: "视频编号", name: "id", title: "id", isHtml: false, value: this.getObjValue },
        { state: true, alias: "讲师名称", name: "lecturerName", title: "lecturerName", isHtml: false, value: this.getObjValue },
        { state: true, alias: "视频标题", name: "title", title: "title", isHtml: false, value: this.getObjValue },
        { state: true, alias: "视频类型", name: "type", title: "type", isHtml: false, value: this.getObjValue },
        { state: true, alias: "所属品牌", name: "brandName", title: "brandName", isHtml: false, value: this.getObjValue },
        { state: true, alias: "视频价格", name: "price", title: "price", isHtml: false, value: this.getObjValue },
        { state: true, alias: "视频状态", name: "state", title: "state", isHtml: true, value: this.getObjValue },
        { state: true, alias: "上传时间", name: "createTime", title: "createTime", isHtml: false, value: this.getObjValue },
        { state: true, alias: "上传人", name: "creator", title: "creator", isHtml: false, value: this.getObjValue }
      ]
    };
  },
  computed: {
    isOperation() {
      return this.$hasAuthority(2500000,2502000,[2502002,2502003,2502008]);
    },
    tableFieldNum() {
      let num = this.isOperation ? 1 : 0;
      this.tableField.forEach(function(value) {
        if (value.state) {
          ++num;
        }
      });
      return num;
    }
  },
  methods: {
    getObjValue(item, field) {
      if (field === "state") {
        switch (item[field]) {
          case 0: return "<span class='red-txt'>禁用</span>";
          case 1: return "<span class='success-txt'>启用</span>";
          case 3: return "<span>处理中</span>";
          default: return "<span>其他</span>";
        }
      } else if (field === "type") {
        switch (item[field]) {
          case 1: return "基础视频";
          case 2: return "专题培训";
          case 3: return "属具安装";
          case 4: return "视频案例";
          default : return ""
        }
      } else if (field === "price") {
        return item[field] === 0 ? "免费" : `${item[field] / 100}元`
      } else {
        return item[field];
      }
    },
    onReloadData() {
      this.reloadData = true;
    },
    onSearch() {
      this.queryParams.type = this.searchType;
      this.queryParams.msg = this.searchMsg.trim();
    },
    onShowAdd() {
      this.$layer.iframe({
        content: {
          content: VideoAddLayer,
          parent: this,
          data: {
            refreshData: this.onReloadData
          }
        },
        area: ["550px", "600px"],
        title: "添加视频"
      });
    },
    onShowEdit(itemId) {
      this.$layer.iframe({
        content: {
          content: VideoEditLayer,
          parent: this,
          data: {
            lecturerVideoId: itemId,
            refreshData: this.onReloadData
          }
        },
        area: ["550px", "450px"],
        title: "编辑视频"
      });
    },
    onDel(item) {
      this.$layer.confirm(`是否删除视频【${item.title}】？`, layerid => {
        postLecturerVideoDel({ id: item.id })
          .then(() => {
            this.$layer.msg("操作成功");
            this.onReloadData();
            this.$layer.close(layerid);
          })
          .catch(error => {
            this.$layer.close(layerid);
            if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
              this.$layer.msg(error.data.msg);
            } else {
              this.$layer.msg("操作失败");
            }
          });
      });
    },
    onChangeState(item, isEnable) {
      this.$layer.confirm(`是否【${isEnable ? "启用" : "禁用"}】视频【${item.title}】？`, layerid => {
        postLecturerVideoState({ id: item.id, state: isEnable ? 1 : 0 })
          .then(() => {
            this.$layer.msg("操作成功");
            this.onReloadData();
            this.$layer.close(layerid);
          })
          .catch(error => {
            this.$layer.close(layerid);
            if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
              this.$layer.msg(error.data.msg);
            } else {
              this.$layer.msg("操作失败");
            }
          });
      });
    },
    onToCommentsPage(item) {
      this.$router.push({ name: "VideoComments", query: { id: item.id } });
    },
    onToQuestionPage(item) {
      this.$router.push({ name: "VideoQuestions", query: { id: item.id } });
    }
  }
}
</script>

<style lang="less" scoped>
.child-page-div {
  width: 100%;
  .page-content-div {
    border-radius: 5px;
    background-color: #ffffff;
    padding: 30px 20px 10px 20px;
    .search-div {
      height: 100%;
      display: flex;
      select {
        width: 110px;
        height: 100%;
        border: 1px solid #dcdcdc;
      }
      .search-input {
        width: 140px;
        height: 33px;
        border: 1px solid #dcdcdc;
        padding: 0 15px;
        margin-left: 5px;
      }
      .search-btn {
        width: 80px;
        height: 100%;
        color: #f4f6f5;
        border: none;
        background: #4676c8;
      }
    }
    .operation-th {
      width: 200px;
    }
    .table-sub-head-th {
      .div-btn {
        float: left;
        width: 88px;
        height: 23px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-right: 10px;
        }
      }
      .append-btn {
        margin-left: 15px;
        margin-right: 10px;
      }
    }
    .operation-btn-div {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>